import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'

export function getLocalizedText(
    lang: TLang,
    texts: Record<TLang, LocalizedText>
): LocalizedText {
    return texts[lang] ?? texts.en
}
